import { inject, Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
} from '@angular/router';
import { MenuStore } from '../../layout/components/menu/menu.store';
import { FilterBuilder } from '../helper/filter.builder';

@Injectable({
    providedIn: 'root',
})
export class ServiceIdGuard implements CanActivate {
    protected readonly store = inject(MenuStore);
    protected readonly router = inject(Router);

    async canActivate(_route: ActivatedRouteSnapshot): Promise<boolean> {
        const serviceId = _route.params?.serviceId;

        if (this.store.services()?.length && this.store.services()?.find(s => s.id === Number(serviceId))) {
            return true;
        }
        // after reload
        const res = await this.store.api
            .getServices(FilterBuilder.singlePage({ id: serviceId }), 'id');

        if (!res?.items.length) {
            await this.router.navigateByUrl('/content/services');
            return false;
        }

        return true;
    }
}
